import { InteractionsLogger } from './interactionsLogger';
import { mapInteractionToPicoXPromotedEvent, PicoXPromotedEvent } from './picoxInteractionsMapper';
import { trackPicoXEvent } from './picoxTrackBridge';
import { EventInteraction, EventInteractionContext, EventInteractions } from '@/utils/tracking';

/**
 * Emits PicoX promoted impression/click events from the shared interaction
 * batcher, AFTER `EventsInteractionsTracker` has applied its unique-impression
 * guard. Running here (rather than firing directly in `useTracking`) is what
 * keeps PicoX impressions 1:1 with the `log_engagement` impressions: both sinks
 * consume the same deduped `(id, placementId, action)` stream, so a duplicate
 * impression dropped for engagement is dropped for PicoX too.
 *
 * Ported from eb-ui `packages/attendee/ads/src/tracking/interactionsPicoXLogger.ts`.
 */
export class InteractionsPicoXLogger extends InteractionsLogger<PicoXPromotedEvent> {
    protected allowedEvents: EventInteractions[] = [
        EventInteractions.Impression,
        EventInteractions.Click,
    ];

    protected filterEventsBy(interaction: EventInteraction<EventInteractionContext>) {
        return Boolean(mapInteractionToPicoXPromotedEvent(interaction));
    }

    protected transformInteraction(
        interaction: EventInteraction<EventInteractionContext>,
    ): PicoXPromotedEvent {
        return mapInteractionToPicoXPromotedEvent(interaction) as PicoXPromotedEvent;
    }

    protected log(events: PicoXPromotedEvent[]) {
        events.forEach(({ name, payload }) => trackPicoXEvent(name, payload));
    }
}
